"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _react = _interopRequireDefault(require("react"));

var _stringConstants = require("./stringConstants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var validCharacterSetOne = _stringConstants.validCharacterSetOne;
var validCharacterSetTwo = _stringConstants.validCharacterSetTwo;
exports.__esModule = true;
exports.default = exports.array = exports.object = exports.boolean = exports.date = exports.number = exports.string = exports.mixed = void 0;

var _printValue = _interopRequireDefault(require("./util/printValue"));

var inputValue = null;
var name = null;
var tempText = '';
var firstInt = 0;
var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var myStringLocale = _ref.myStringLocale;
    var reg = new RegExp("[^" + validCharacterSetOne.source + validCharacterSetTwo.source + "]", "g");
    var errorValues = originalValue.match(reg) ? originalValue.match(reg) : [];
    var isCast = originalValue != null && originalValue !== value;
    var errDisplay = [];

    for (var i = 0; i < errorValues.length; i++) {
      errDisplay[i] = errorValues[i] == '\t' ? "　" : errorValues[i];
    }

    var msg = _react["default"].createElement(_react["default"].Fragment, null, ["使用できない文字", errDisplay ? '「' + errDisplay.join('」「') + '」' : '', "が使われています。", /*#__PURE__*/myStringLocale ? null : _react["default"].createElement("button", {
      class: 'myYupError',
      onClick: function onClick(e) {
        e.preventDefault();

        if (!name || name != path) {
          // ボタン変更の場合、初期化する
          firstInt = 0;
          name = path;
          inputValue = originalValue;
          tempText = originalValue;
        } else {
          if (!inputValue || inputValue != originalValue) {
            // 項目内容変更の場合、初期化する
            firstInt = 0;
            inputValue = originalValue;
            tempText = originalValue;
          }
        } // 項目取得する


        var targetDom = document.getElementsByName(path);

        if (targetDom && targetDom.length > 0) {
          for (var _i = firstInt; _i < errorValues.length; _i++) {
            var m = tempText.indexOf(errorValues[_i]);
            var n = originalValue.length - tempText.length; // フォーカス設定

            targetDom[targetDom.length - 1].focus();

            if (window.navigator.userAgent.toLocaleLowerCase().match(/(trident)\/([\d.]+)/)) {
              if (targetDom[targetDom.length - 1].type == 'text') {
                var range = targetDom[targetDom.length - 1].createTextRange();
                range.collapse(true);
                range.moveStart('character', n + m);
                range.moveEnd('character', 1);
                range.select();
              } else {
                targetDom[targetDom.length - 1].setSelectionRange(n + m, n + m + 1);
              }
            } else {
              targetDom[targetDom.length - 1].setSelectionRange(n + m, n + m + 1);

              if (targetDom[targetDom.length - 1].type == 'text' && targetDom[targetDom.length - 1].value.length > 0) {
                var f = targetDom[targetDom.length - 1].clientWidth / targetDom[targetDom.length - 1].scrollWidth;
                var left = targetDom[targetDom.length - 1].scrollWidth * (n + m) / targetDom[targetDom.length - 1].value.length - targetDom[targetDom.length - 1].clientWidth / 2;
                targetDom[targetDom.length - 1].scrollLeft = left;
              }
            } // 使用できない文字List最後の場合、変量初期化する


            if (_i + 1 === errorValues.length) {
              firstInt = 0;
              tempText = originalValue;
            } else {
              // 使用できない文字List開始位置の設定
              firstInt++; // Temp入力内容substing

              tempText = tempText.substring(m + 1);
            }

            return;
          }
        }
      }
    }, "特定する"), myStringLocale ? null : /*#__PURE__*/_react["default"].createElement("br", null, null), "環境依存文字の確認は", /*#__PURE__*/_react["default"].createElement("a", {
      href: "",
      onClick: function onClick(e) {
        e.preventDefault();
        window.open("/envCharManual", "_blank", "scrollbars=yes,resizable=yes,status=no,location=no,toolbar=no,menubar=no,width=" + 1280 + ",height=" + 948 + ",left=" + 10 + ",top=" + 10 + "");
      }
    }, "こちら"), "よりお願いします。"]);

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  }
};
exports.mixed = mixed;
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
exports.string = string;
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
exports.number = number;
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
exports.date = date;
var boolean = {};
exports.boolean = boolean;
var object = {
  noUnknown: '${path} field cannot have keys not specified in the object shape'
};
exports.object = object;
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};
exports.array = array;
var _default = {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
};
exports.default = _default;